import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { checkStartExam, endExam, getExam } from '../service/cTest';
import { useNavigate, Link } from "react-router-dom";
import { errorMessage, infoMessage, successMessage } from '../utils/toastMessage';




const TestC = () => {
    const [getExamId,setExamId]=useState()
    const [getTime, setTime] = useState(0)
    const [getStartTime, setStartTime] = useState(new Date().getTime())
    const [getTestNumber, setTestNumber] = useState(0)
    const [getPassMark, setPassMark] = useState(0)
    const [getNumberTrue, setNumberTrue] = useState(0)
    const [getQuestionsId, setQuestionsId] = useState([])
    const [getQuestions, setQuestions] = useState([])
    const [getCurrentQestion, setCurrentQuestion] = useState("")
    const [getTitle, setTitle] = useState('')
    const [getNow, setNow] = useState()
    const [getCurrentAnswer, setCurrentAnswer] = useState()
    const [getUserCurrentAnswer, setUserCurrentAnswer] = useState(0)

    const username = useParams().username
    const user = useSelector((state) => state.user)
    const navigate = useNavigate();

    // console.log(getUserCurrentAnswer);

    const handleGetExam = async () => {
        try {
            const { status, data } = await getExam(user.value.username);
            if (status === 200) {

                var payment = data.payment.filter(p => p.user == data.userId && p.isExamed == false)[0]
                var examId = payment.exam
                setExamId(examId)
                var exam = data.exam.filter(e => e.id == examId)[0]

                setTime(exam.time)
                setTestNumber(exam.number)
                setPassMark(exam.passMark)
                setQuestions(data.question)
                setTitle(exam.title)
                var randomMemeber = exam.questions[(Math.floor(Math.random() * exam.questions.length))]

                var newQuestionId = exam.questions.filter(function (letter) {
                    return letter !== randomMemeber;
                });


                setQuestionsId(newQuestionId)
                setCurrentQuestion(data.question.filter(q => q.id == randomMemeber)[0])
                setCurrentAnswer(data.question.filter(q => q.id == randomMemeber)[0].trueAnswer)
            }
        } catch (ex) {
        }
    }


    const handleCheckStartExam = async () => {
        try {
            const { status, data } = await checkStartExam(user.value.username);
            if (status === 200) {
                console.log(data);
                if (data.status == "nok") {
                    navigate("/dashboard/cTest")
                }
            }
        } catch (ex) {
        }
    }


    const beforeUnloadListener = (event) => {
        event.preventDefault();
        return (event.returnValue = "");
    };

    useEffect(() => {
        setInterval(() => {
            setNow(new Date().getTime())
        }, 1000)
    }, [])

    useEffect(() => {
        if (Math.floor(getTime / getTestNumber) - Math.floor((getNow - getStartTime) / 1000) <= 0) {
            if (getQuestionsId.length == 0) {
                if (getCurrentAnswer == getUserCurrentAnswer) {
                    if(getNumberTrue+1>=getPassMark){
                        successMessage("شما نمره قبولی را به دست آوردید")
                    }
                    else{
                        errorMessage("شما نمره قبولی را به دست نیاوردید")
                    }
                    const { status, data } = endExam(user.value.username,getNumberTrue+1,getExamId);
                    navigate("/dashboard")
                }
                else{
                    if(getNumberTrue>=getPassMark){
                        successMessage("شما نمره قبولی را به دست آوردید")
                    }
                    else{
                        errorMessage("شما نمره قبولی را به دست نیاوردید")
                    }
                    const { status, data } = endExam(user.value.username,getNumberTrue+1,getExamId);
                    navigate("/dashboard")
                }
            }
            else {
                if (getCurrentAnswer == getUserCurrentAnswer) {
                    setNumberTrue(getNumberTrue + 1)
                }



                setStartTime(new Date().getTime())
                setUserCurrentAnswer(0)
                document.getElementById("none").checked = true


                var randomMemeber = getQuestionsId[(Math.floor(Math.random() * getQuestionsId.length))]
                var newQuestionId = getQuestionsId.filter(function (letter) {
                    return letter !== randomMemeber;
                });
                setQuestionsId(newQuestionId)
                setCurrentQuestion(getQuestions.filter(q => q.id == randomMemeber)[0])
                setCurrentAnswer(getQuestions.filter(q => q.id == randomMemeber)[0].trueAnswer)
            }


        }
    })

    useEffect(() => {
        handleGetExam()
        handleCheckStartExam()
        window.addEventListener("beforeunload", beforeUnloadListener, { capture: true });
        document.querySelector(".header").style.display = "none"
        document.querySelector(".footer").style.display = "none"
        return (
            () => {
                document.querySelector(".header").style.display = "flex"
                document.querySelector(".footer").style.display = "block"
                window.removeEventListener("beforeunload", beforeUnloadListener, {
                    capture: true,
                });
            }
        )
    }, [])

    const handleNext = () => {
        if (getCurrentAnswer == getUserCurrentAnswer) {
            setNumberTrue(getNumberTrue + 1)
        }



        setStartTime(new Date().getTime())



        var randomMemeber = getQuestionsId[(Math.floor(Math.random() * getQuestionsId.length))]
        var newQuestionId = getQuestionsId.filter(function (letter) {
            return letter !== randomMemeber;
        });
        setQuestionsId(newQuestionId)
        setCurrentQuestion(getQuestions.filter(q => q.id == randomMemeber)[0])
        setCurrentAnswer(getQuestions.filter(q => q.id == randomMemeber)[0].trueAnswer)


        setUserCurrentAnswer(0)
        document.getElementById("none").checked = true

    }
    const handleEnd = () => {
        if (getCurrentAnswer == getUserCurrentAnswer) {
            if(getNumberTrue+1>=getPassMark){
                successMessage("شما نمره قبولی را به دست آوردید")
            }
            else{
                errorMessage("شما نمره قبولی را به دست نیاوردید")
            }
            const { status, data } = endExam(user.value.username,getNumberTrue+1,getExamId,"ok");
            navigate("/dashboard")
        }
        else{
            if(getNumberTrue>=getPassMark){
                successMessage("شما نمره قبولی را به دست آوردید")
            }
            else{
                errorMessage("شما نمره قبولی را به دست نیاوردید")
            }
            const { status, data } = endExam(user.value.username,getNumberTrue+1,getExamId,"nok");
            navigate("/dashboard")
        }
    }



    return (
        <>
            <div className='exam'>
                <div className='head'>
                    <span>{getTitle}</span>
                    <span>
                        <span>زمان باقی مانده این سوال  </span>
                        <span>{Math.floor(getTime / getTestNumber) - Math.floor((getNow - getStartTime) / 1000)}</span>
                    </span>
                </div>
                <hr />
                <div className="question" dangerouslySetInnerHTML={{ __html: getCurrentQestion.title }}>
                </div>
                <div className='answer' style={{ marginBottom: "50px" }}>
                    <input type="radio" id="none" name="a" value="0" style={{ display: "none" }} />
                    <input type="radio" id="1" name="a" value="1" onClick={() => setUserCurrentAnswer(1)} />
                    <label htmlFor="1">{getCurrentQestion.answer1}</label>
                    <br />
                    <input type="radio" id="2" name="a" value="2" onClick={() => setUserCurrentAnswer(2)} />
                    <label htmlFor="2">{getCurrentQestion.answer2}</label>
                    <br />
                    <input type="radio" id="3" name="a" value="3" onClick={() => setUserCurrentAnswer(3)} />
                    <label htmlFor="3">{getCurrentQestion.answer3}</label>
                    <br />
                    <input type="radio" id="4" name="a" value="4" onClick={() => setUserCurrentAnswer(4)} />
                    <label htmlFor="4">{getCurrentQestion.answer4}</label>
                </div>
                <hr />
                <div className='foot'>
                    {getQuestionsId.length == 0 ? (
                        <button onClick={handleEnd}>پایان آزمون</button>
                    ) : (
                        <button onClick={handleNext}>سوال بعدی</button>
                    )}
                </div>
            </div>
        </>
    )
}



export default TestC